import './sass/style.scss';
import './js/jquery.global.js';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import './js/owl.carousel.js';
// import './js/plyr.js';
import './js/layout.js';
import './js/bootstrap/util.js';
import './js/bootstrap/dropdown.js';
import './js/tabs.js';
